import { render, staticRenderFns } from "./KingdomBuildBoard.vue?vue&type=template&id=d82024b4&scoped=true"
import script from "./KingdomBuildBoard.vue?vue&type=script&lang=js"
export * from "./KingdomBuildBoard.vue?vue&type=script&lang=js"
import style0 from "./KingdomBuildBoard.vue?vue&type=style&index=0&id=d82024b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82024b4",
  null
  
)

export default component.exports